import { ApiResponse, Service } from '@roc/feature-app-core';

const url = {
  GET_DASHBOARD: '/api/v1/doc-review/aiDocReview/qcDashboard',
  COMPLETE_REVIEW: '/api/v1/doc-review/aiDocReview/qcDashboard/complete',
  SEND_REVISION: '/api/v1/doc-review/aiDocReview/sendRevision',
};

export class QcDashboardService extends Service {
  getDashboard(page: number, pageSize: number, sortDir: string, sortBy: string, filters: object,
    dropdownFilters: object): Promise<ApiResponse> {
    return this.get(url.GET_DASHBOARD, { page, pageSize, sortDir, sortBy, filters, dropdownFilters });
  }

  completeReview(loanId: number): Promise<ApiResponse> {
    return this.post(`${url.COMPLETE_REVIEW}?loanId=${loanId}`, {});
  }

  sendRevision(loanId: number): Promise<ApiResponse> {
    return this.get(url.SEND_REVISION, {
      id: loanId,
      docType: 'POST_CLOSING_REVIEW',
      includeAttachment: true,
    });
  }
}
